module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label":"Land auswählen"},"fr":{"label":"Sélectionner le pays"},"it":{"label":"Scelga il paese"}}')
  delete Component.options._Ctor
}
